import React from 'react';
import BookLandingPage from './BookLandingPage';

const pageUrl = 'https://jerryevanoff.com/books/inheriting-murder';
const coverImage = 'https://jerryevanoff.com/images/CoverBook2.jpg';

const bookSchema = {
  '@context': 'https://schema.org',
  '@type': 'Book',
  name: 'Inheriting Murder',
  headline: 'Inheriting Murder by Jerry Evanoff',
  author: {
    '@type': 'Person',
    name: 'Jerry Evanoff',
    url: 'https://jerryevanoff.com'
  },
  isPartOf: {
    '@type': 'BookSeries',
    name: 'Sam Norris Murder Mystery Series',
    url: 'https://jerryevanoff.com/books'
  },
  position: 2,
  bookFormat: 'https://schema.org/EBook',
  bookEdition: 'Book 2',
  datePublished: '2026-04-28',
  genre: [
    'Amateur Sleuth Mystery',
    'Murder Mystery',
    'Modern Whodunit',
    'Golf Course Mystery',
    'Cold Case Mystery',
    'Savannah Mystery',
    'Soft-Boiled Mystery'
  ],
  keywords: [
    'Inheriting Murder',
    'Jerry Evanoff',
    'Sam Norris Murder Mystery Series',
    'amateur sleuth murder mystery',
    'modern whodunit',
    'Savannah mystery',
    'golf course murder mystery',
    'inheritance mystery',
    'cold case mystery',
    'tech-savvy sleuth',
    'programmer detective',
    'Agatha Christie-style mystery'
  ],
  description: 'Inheriting Murder by Jerry Evanoff is a modern amateur sleuth mystery featuring tech-savvy programmer Sam Norris, a Savannah golf course murder, a contentious will, family secrets and a seventeen-year-old cold case.',
  image: coverImage,
  url: pageUrl,
  offers: [
    {
      '@type': 'Offer',
      name: 'Inheriting Murder eBook',
      url: 'https://www.amazon.com/dp/B0GX2YHJG4',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Amazon'
      }
    },
    {
      '@type': 'Offer',
      name: 'Inheriting Murder paperback',
      url: 'https://www.amazon.com/dp/B0GX2YHJG4',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Amazon'
      }
    },
    {
      '@type': 'Offer',
      name: 'Signed Inheriting Murder paperback',
      url: 'https://www.etsy.com/shop/JerryEvanoffAuthor?section_id=58596111',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Jerry Evanoff Author Etsy Shop'
      }
    }
  ]
};

const InheritingMurder = () => (
  <BookLandingPage
    pageUrl={pageUrl}
    pageTitle="Inheriting Murder by Jerry Evanoff | Sam Norris Murder Mystery Book 2"
    pageDescription="Inheriting Murder by Jerry Evanoff is a modern amateur sleuth mystery featuring tech-savvy programmer Sam Norris, a Savannah golf course murder, a contentious will, family secrets and a seventeen-year-old cold case."
    metaKeywords="Inheriting Murder, Jerry Evanoff, Sam Norris Murder Mystery Series, amateur sleuth murder mystery, Savannah mystery, golf course murder mystery, inheritance mystery, cold case mystery, modern whodunit, tech-savvy sleuth, programmer detective, Agatha Christie-style mystery"
    coverImage={coverImage}
    title="Inheriting Murder"
    subtitle="Book 2 in the Sam Norris Murder Mystery Series"
    genreLine={(
      <>
        <strong>Inheriting Murder</strong> is a modern amateur sleuth mystery
        featuring Sam Norris, a tech-savvy programmer pulled into a Savannah golf
        course murder after a family will reading turns deadly.
      </>
    )}
    bodyParagraphs={[
      { text: 'At Savannah Palms Golf Course, the most dangerous hazards are not along the fairways.' },
      { text: 'Sam Norris returned home to Savannah for a quieter life, a new relationship and a chance to improve his golf swing. But when the patriarch of the legendary Savannah Palms Golf Course dies, the reading of his will exposes a legacy of greed, resentment and family secrets.' },
      { text: 'Then a member of the family dies only minutes after the will is read.', bold: true },
      { text: "The case takes a darker turn when Sam's best friend, Carey Layne, is found standing over another dead body holding the bloody weapon. To the police, the case looks simple." },
      { text: 'Sam sees it a different way.', bold: true },
      { text: 'Clearing Carey means digging through secret affairs, Las Vegas ghosts, bitter family feuds and a seventeen-year-old cold case involving a local girl who vanished from Savannah without a trace.' },
      { text: "In a town where nearly everyone is hiding something, Sam has to spot what everyone else missed before the killer's lies become permanent." }
    ]}
    perfectForText="amateur sleuth mysteries, Savannah murder mysteries, golf course mysteries, inheritance mysteries, family-secret whodunits, cold case mysteries, tech-savvy sleuths, programmer detectives and old-school puzzle plots."
    buyLinks={{
      ebookAmazonUrl: 'https://www.amazon.com/dp/B0GX2YHJG4?maas=maas_adg_1C827B7B6F4B4F456093863079817DAA_afap_abs&ref_=aa_maas&tag=maas',
      paperbackAmazonUrl: 'https://www.amazon.com/Inheriting-Murder-Sam-Norris-Mystery/dp/B0GZFRRPZC',
      paperbackBOUrl: 'https://www.barnesandnoble.com/w/inheriting-murder-jerry-evanoff/1150081276',
      etsySignedPaperbackUrl: 'https://www.etsy.com/shop/JerryEvanoffAuthor?section_id=58596111'
    }}
    readingOrder={[
      { title: 'Manufacturing Murder', subtitle: 'Book 1' },
      { title: 'The Library (Novella)', subtitle: 'Book 1.5' },
      { title: 'Inheriting Murder', subtitle: 'Book 2', current: true },
      { title: 'Networking Murder', subtitle: 'Book 3' }
    ]}
    schema={bookSchema}
  />
);

export default InheritingMurder;
